import { tradeDate } from '@/components/Ciso/BaseStore/CisoConfigs';

const options = {
  columnConfig: true,
  columnsMovable: true,
  exportExcel: true,
  filterHeader: true,
  filterRow: true,
};

export default {
  dockConfig: {
    visible: false,
    alignment: 'left',
  },
  searchFiltersConfig: {
    tradeDate,
  },
  fields: [{
    caption: 'TRADING DATE',
    dataField: 'date',
    dataType: 'date',
    format: 'yyyy-MM-dd',
    area: 'row',
    expanded: true,
  }, {
    caption: 'RESOURCE ID',
    dataField: 'rsrcId',
    dataType: 'string',
    area: 'row',
    expanded: true,
    width: 400,
  }, {
    caption: 'RESOURCE TYPE',
    dataField: 'rsrcType',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'INTERTIE TYPE',
    dataField: 'intertieType',
    dataType: 'string',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'PROFILE TYPE',
    dataField: 'profType',
    dataType: 'string',
    area: 'column',
    expanded: true,
    sortingMethod(a, b) {
      const indexFinder = (nm) => {
        if (nm === 'CMRI') return 1;
        if (nm === 'TagSettlements') return 2;
        return 100;
      };
      const indexA = indexFinder(a.value);
      const indexB = indexFinder(b.value);
      if (indexA < indexB) return -1;
      if (indexA > indexB) return 0;
      return 1;
    },
  }, {
    caption: 'MARKET TYPE',
    dataField: 'mktType',
    dataType: 'string',
    area: 'column',
    expanded: true,
    allowSorting: false,
    sortingMethod(a, b) {
      const indexFinder = (nm) => {
        if (nm === 'BASE') return 1;
        if (nm === 'FMM') return 2;
        if (nm === 'RTD' || nm === 'ATF') return 4;
        return 100;
      };
      const indexA = indexFinder(a.value);
      const indexB = indexFinder(b.value);
      if (indexA < indexB) return -1;
      if (indexA > indexB) return 0;
      return 1;
    },
  }, {
    caption: 'HOUR',
    dataField: 'he',
    dataType: 'number',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'INTERVAL',
    dataField: 'ie',
    dataType: 'number',
    area: 'filter',
    expanded: true,
  }, {
    caption: 'VOLUME',
    dataField: 'vol',
    dataType: 'number',
    area: 'data',
    summaryType: 'sum',
    expanded: true,
    format: { type: 'fixedPoint', precision: 2 },
    calculateSummaryValue: (e) => {
      let sum = 1;
      let file = 0;
      let compare = 0;
      if (e.children('row') && e.children('row').length > 0 && e.children('row')[0]._rowPath.length > 0 && e.children('row')[0]._rowPath[0].text === 'Settlement') {
        compare = e.children('row')[0] ? e.children('row')[0]._cell[0] : 0;
        file = e.children('row')[1] ? e.children('row')[1]._cell[0] : 0;
        sum = compare - file;
        if (sum > -0.0001 && sum < 0.0001) { sum = 0; }
        return sum;
      } if (e.children('row') && e.children('row').length > 0 && e.children('row')[0]._rowPath.length > 0 && e.children('row')[0]._rowPath[0].text === 'Tag') {
        file = e.children('row')[0] ? e.children('row')[0]._cell[0] : 0;
        compare = e.children('row')[1] ? e.children('row')[1]._cell[0] : 0;
        sum = file - compare;
        if (sum > -0.0001 && sum < 0.0001) { sum = 0; }
        return sum;
      }

      return e.cell() && e.cell().originalCell.length > 0 ? e.cell().originalCell[0] : 0;
    },
  }],
};